"use strict";
var ACC;
ACC.payment = {
		
		activateSavedPaymentButton: function(){

			$(document).on("click",".js-saved-payments",function(e){
				e.preventDefault();
				
				var title = $("#savedpaymentstitle").html();
				
				$.colorbox({
					href: "#savedpaymentsbody",
					inline:true,
					maxWidth:"100%",
					opacity:0.7,
					width:"320px",
					title: title,
					close:'<span class="glyphicon glyphicon-remove"></span>',
					onComplete: function(){
					}
				});
			});
		},
		bindPaymentCardTypeSelect: function ()
		{
			ACC.payment.filterCardInformationDisplayed();
			$("#card_cardType").change(function ()
			{
				var cardType = $(this).val();
				if (cardType === '024')
				{
					$('#startDate, #issueNum').show();
				}
				else
				{
					$('#startDate, #issueNum').hide();
				}
			});
		},
		filterCardInformationDisplayed: function ()
		{
			var cardType = $('#card_cardType').val();
			if (cardType === '024')
			{
				$('#startDate, #issueNum').show();
			}
			else
			{
				$('#startDate, #issueNum').hide();
			}
		},
		
		bindCardValidation: function(){
			$('.gift-card-number .form-group input[type="number"]').blur(function(){
				 var txtValue = $.trim($(this).val()),
				 	$parentClass = $(this).closest(".form-group"),
				 	cardLength = parseInt($('#giftCardLength').val()),
				 	validateErrorMsg = $('#giftCardValidateError').val(),
				 	blankErrorMsg = $('#giftCardBlankError').val(),
					errorMsg;
				 
					if (txtValue.length === 0){
						errorMsg = blankErrorMsg;
					} else {
						errorMsg = validateErrorMsg;
					}
				 	var divStr = "<div class=\"help-block\"><span role=\"alert\">" +  errorMsg + "</span></div>";
					if (txtValue.length !== cardLength){
						 if ($parentClass.find('i').length > 0){
							 $parentClass.find('i').remove();
							 $parentClass.prepend('<i class="icon icon-cancel-circled error" aria-hidden="true"></i>');
							 if ($parentClass.find('div.help-block').length === 1) {
								 $parentClass.find('div.help-block').html(errorMsg);
							 } else {
								 $parentClass.append(divStr);
							 }
						 } else {
							 $parentClass.prepend('<i class="icon icon-cancel-circled error" aria-hidden="true"></i>');
							 if ($parentClass.find('div.help-block').length === 1) {
								 $parentClass.find('div.help-block').html(errorMsg);
							 } else {
								 $parentClass.append(divStr);
							 }
						 }
						 // Add aria-invalid="true" to the input field when error triggered
						 $(this).attr('aria-invalid', 'true');
						 $parentClass.addClass('has-error'); 
						
					 } else {
						if ($parentClass.find('i').length > 0) {
							$parentClass.find('i').remove();
						}
						var giftCardRegexError = $('#giftCardRegexError').val();
						var giftCardRegexProperty = $('#giftCardPattern').val();
						var giftCardRegex = new RegExp(giftCardRegexProperty);
						if (giftCardRegex.test(txtValue)) {
							$(this).closest(".form-group").prepend('<i class="tick icon icon-check-circle" aria-hidden="true"></i>');
							$parentClass.removeClass('has-error');
							$parentClass.find('.help-block').remove();
							// Add aria-invalid="true" to the input field when error triggered
                            $(this).attr('aria-invalid', 'false');
						} else {
							divStr = "<div class=\"help-block\"><span>" +  giftCardRegexError + "</span></div>";
							$(this).closest(".form-group").prepend('<i class="icon icon-cancel-circled error" aria-hidden="true"></i>');
							if ($parentClass.find('div.help-block').length === 1) {
								$parentClass.find('div.help-block').html(giftCardRegexError);
							} else {
								$parentClass.append(divStr);
							}
							 $parentClass.addClass('has-error'); 
							 // Add aria-invalid="true" to the input field when error triggered
							 $(this).attr('aria-invalid', 'true');
						}
					 }

					  // Use the helper method to handle the error message container
					  ACC.payment.handleErrorMessageContainer(this, 'giftCardNumber', $parentClass);
			});
			
			$('.gift-card-pin .form-group input[type="number"]').blur(function(){
				var txtValue = $.trim($(this).val()),
				 	$parentClass = $(this).closest(".form-group"),
				 	pinLength =  parseInt($('#giftCardPinLength').val()),
				 	validateErrorMsg = $('#pinNoValidateError').val(),
				 	blankErrorMsg = $('#pinNoBlankError').val(),
					errorMsg;
				 
				if (txtValue.length === 0){
					 errorMsg = blankErrorMsg;
				} else {
					 errorMsg = validateErrorMsg;
				}
				var divStr = "<div class=\"help-block\"><span role=\"alert\">" +  errorMsg + "</span></div>";
				if (txtValue.length !== pinLength){
					 if ($parentClass.find('i').length > 0){
						 $parentClass.find('i').remove();
						 $parentClass.prepend('<i class="icon icon-cancel-circled error" aria-hidden="true"></i>');
						 if ($parentClass.find('div.help-block').length === 1) {
							 $parentClass.find('div.help-block').html(errorMsg);
						 } else {
							 $parentClass.append(divStr);
						 }
					 } else {
						 $parentClass.prepend('<i class="icon icon-cancel-circled error" aria-hidden="true"></i>');
						 if ($parentClass.find('div.help-block').length === 1) {
							 $parentClass.find('div.help-block').html(errorMsg);
						 } else {
							 $parentClass.append(divStr);
						 }
					 }
					 // Add aria-invalid="true" to the input field when error triggered
					 $(this).attr('aria-invalid', 'true');
					 $parentClass.addClass('has-error'); 
					
				 } else {
					if ($parentClass.find('i').length > 0) {
						$parentClass.find('i').remove();
					}
					$(this).closest(".form-group").prepend('<i class="tick icon icon-check-circle" aria-hidden="true"></i>');
					$parentClass.removeClass('has-error');
					$parentClass.find('.help-block').remove();
					// Add aria-invalid="true" to the input field when error triggered
                    $(this).attr('aria-invalid', 'false');
				 }		
				
				 // Use the helper method to handle the error message container
				 ACC.payment.handleErrorMessageContainer(this, 'giftCardPin', $parentClass);
			});		
		},

		 // Helper method to handle error message container logic
		 handleErrorMessageContainer: function (element, containerPrefix, parentClass) {
			// Get the dynamic index from the data-index attribute
			const index = $(element).closest(`[data-index]`).data('index'); 

			// Get the error message container & dynamically construct the error message container ID
			const errorContainer = document.getElementById(`${containerPrefix}-${index}-error-message`);
			
			// Check if the error message container exists
			if (errorContainer) {
				// Find the .help-block that belongs to this input field
				const helpBlock = parentClass.find('.help-block');
				// If there's a help block, move its content to the error container
				if (helpBlock && helpBlock.length > 0) {
					errorContainer.appendChild(helpBlock[0]);
				} else {
					errorContainer.innerHTML = ''; // Clear if no help block
				}
			}
		},
};

$(document).ready(function () {
		ACC.payment.activateSavedPaymentButton();
		ACC.payment.bindPaymentCardTypeSelect();
		ACC.payment.bindCardValidation();
});
